import { Utils } from 'cc-common';
import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';

export class BoardApprovalQueueParameterDto {
    itemId: number;
    communityId: number;
    isClosedQueue: boolean;
    myTask: boolean;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    beginDueDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    endDueDate: Date;

    getQueryString(): string {
        const tokens = [];

        if (Utils.notNullAndDefined(this.isClosedQueue)) {
            tokens.push(`isClosedQueue=${this.isClosedQueue}`);
        }

        if (Utils.notNullAndDefined(this.myTask)) {
            tokens.push(`myTask=${this.myTask}`);
        }

        if (Utils.notNullOrEmpty(this.communityId)) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (Utils.notNullAndDefined(this.beginDueDate)) {
            tokens.push(`beginDueDate=${dateJSONTransformer(this.beginDueDate)}`);
        }

        if (Utils.notNullAndDefined(this.endDueDate)) {
            tokens.push(`endDueDate=${dateJSONTransformer(this.endDueDate)}`);
        }

        return Utils.notNullOrEmpty(tokens) ? `?${tokens.join('&')}` : '';
    }
}
